export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13565.3f4e7ae2.jpg";